/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const TrashIcon = () => <FontAwesomeIcon icon={faTrash} />;

export default TrashIcon;
